export default "__VITE_ASSET__S4TktFj7__"